module.exports = function (el) {
  var $el = $(el)

  var $a = $el.find('a')

  var $postContainer = $('#PostList')

  var targetHref = $a.attr('href')

  var itemOnScroll = require('modules/scroll-to')

  $a.on('click', function (e) {
    e.preventDefault()

    $.ajax({
      url: targetHref
    }).done(function (data) {
      var elems = $(data).find('#PageMain').find('.load-more-item')
      for (var i = 0; i < elems.length; i++) {
        $postContainer.append(elems[i]).append(' ')
      }

      // if more posts...

      $('.grid-group-member.gap').remove()

      itemOnScroll()

      var $nextPage = $(data).find('#LoadPosts a')
      if ($nextPage.length) {
        targetHref = $nextPage.attr('href')
        $a.attr('href', targetHref)
      } else {
        $postContainer.append('<div class="grid-group-member gap"></div>')
          .append('<div class="grid-group-member gap"></div>')

        // remove module from page
        $el.remove()
      }
    })
  })
}
